import bemBlock from '@gik/core/utils/bemBlock';
import React from 'react';
import { BaseBoneProps } from './BaseBone';
import ParagraphBone from './ParagraphBone';

const skelBem = bemBlock(`h1-bone`);
interface H1BoneProps extends BaseBoneProps {}

export default function H1Bone({ className }: H1BoneProps) {
  return <ParagraphBone words={4} minWidth={60} maxWidth={140} className={skelBem(undefined, undefined, className)} />;
}
